export default __webpack_public_path__ + "static/ventureAfrica-e243da904222e71221592e0c89b50c0f.png";